//# sourceMappingURL=remote.mjs.map
/// <reference types="./remote.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../gleam.mjs";

export class NotLoaded extends $CustomType {}
export const Remote$NotLoaded = () => new NotLoaded();
export const Remote$isNotLoaded = (value) => value instanceof NotLoaded;

export class Loading extends $CustomType {}
export const Remote$Loading = () => new Loading();
export const Remote$isLoading = (value) => value instanceof Loading;

export class Errored extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Remote$Errored = ($0) => new Errored($0);
export const Remote$isErrored = (value) => value instanceof Errored;
export const Remote$Errored$0 = (value) => value[0];

export class Loaded extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Remote$Loaded = ($0) => new Loaded($0);
export const Remote$isLoaded = (value) => value instanceof Loaded;
export const Remote$Loaded$0 = (value) => value[0];

export function read(remote) {
  if (remote instanceof NotLoaded) {
    return new Error(undefined);
  } else if (remote instanceof Loading) {
    return new Error(undefined);
  } else if (remote instanceof Errored) {
    return new Error(undefined);
  } else {
    let content = remote[0];
    return new Ok(content);
  }
}

export function map(remote, mapper) {
  if (remote instanceof NotLoaded) {
    return remote;
  } else if (remote instanceof Loading) {
    return remote;
  } else if (remote instanceof Errored) {
    return remote;
  } else {
    let l = remote[0];
    return new Loaded(mapper(l));
  }
}

export function then$(remote, next) {
  if (remote instanceof NotLoaded) {
    return remote;
  } else if (remote instanceof Loading) {
    return remote;
  } else if (remote instanceof Errored) {
    return remote;
  } else {
    let content = remote[0];
    return next(content);
  }
}

/**
 * Run the `load_fn` function when `remote` is `NotLoaded`.
 */
export function load(remote, load_fn) {
  if (remote instanceof NotLoaded) {
    return load_fn();
  } else if (remote instanceof Loading) {
    return undefined;
  } else if (remote instanceof Errored) {
    return undefined;
  } else {
    return undefined;
  }
}

export function is_loaded(remote) {
  if (remote instanceof NotLoaded) {
    return false;
  } else if (remote instanceof Loading) {
    return false;
  } else if (remote instanceof Errored) {
    return false;
  } else {
    return true;
  }
}

export function unwrap(remote, default$) {
  if (remote instanceof NotLoaded) {
    return default$;
  } else if (remote instanceof Loading) {
    return default$;
  } else if (remote instanceof Errored) {
    return default$;
  } else {
    let data = remote[0];
    return data;
  }
}

/**
 * Serialize a `Remote(data)` for persistence (e.g. in a jsonb column). The
 * inner `data` is encoded with the caller-provided `encode_data`.
 */
export function encode(remote, encode_data) {
  if (remote instanceof NotLoaded) {
    return $json.object(toList([["status", $json.string("not_loaded")]]));
  } else if (remote instanceof Loading) {
    return $json.object(toList([["status", $json.string("loading")]]));
  } else if (remote instanceof Errored) {
    let message = remote[0];
    return $json.object(
      toList([
        ["status", $json.string("errored")],
        ["message", $json.string(message)],
      ]),
    );
  } else {
    let data = remote[0];
    return $json.object(
      toList([["status", $json.string("loaded")], ["data", encode_data(data)]]),
    );
  }
}

/**
 * Decode the wire format produced by `encode`. Any unknown/missing status
 * falls back to `NotLoaded`, so older stored rows stay readable.
 */
export function decoder(data_decoder) {
  return $decode.field(
    "status",
    $decode.string,
    (status) => {
      if (status === "loading") {
        return $decode.success(new Loading());
      } else if (status === "errored") {
        return $decode.field(
          "message",
          $decode.string,
          (message) => { return $decode.success(new Errored(message)); },
        );
      } else if (status === "loaded") {
        return $decode.field(
          "data",
          data_decoder,
          (data) => { return $decode.success(new Loaded(data)); },
        );
      } else {
        return $decode.success(new NotLoaded());
      }
    },
  );
}
